import React, { useEffect, useState, useCallback, videoRef } from 'react';
import BigImg from '@/assets/images/big-eximg.png';
import SmallImg from '@/assets/images/small-eximg.png';
import './index.less';
import { Button, message } from 'antd';
import { ReactComponent as Vip } from '@/assets/icons/ai/Diamonds.svg';
import { useSelector, useDispatch } from 'react-redux';
import { requestDownload } from '../../../../api/apis';
import Cookies from 'js-cookie';
import action from '../../../../redux/action';
import sentGAEvent from '@/ga';
import { useTranslation } from 'react-i18next';
import Device from 'current-device';
import { useRef } from 'react';

const DownloadPage = (props) => {
  const { t } = useTranslation(['common']);
  const videoRef = useRef(null);
  const reducerData = useSelector((state) => state.common);
  const fetchAbort = useSelector((state) => state.work);
  const [noMarkLoading, setNoMarkLoading] = useState(false);
  const [gifLoading, setGifLoading] = useState(false);
  const [markLoading, setMarkLoading] = useState(false);
  const { subscription } = reducerData;
  const dispatch = useDispatch();
  const downloadFn = (type) => {
    if (type === 'gif') {
      console.log('%c8动图老照片下载视频为GI', 'font-size:20px;color:crimson;');
      window.sessionStorage.reason = '8';
    }
    if (type === 'no_watermark') {
      console.log(
        '%c5：导出/下载无水印（要付费）的文件',
        'font-size:20px;color:crimson;'
      );
      window.sessionStorage.reason = '5';
    }

    if (type === 'watermark') {
      sentGAEvent({
        category: 'AnimateOld',
        action: 'AnimateOld_Download',
        label: 'WithWatermark',
      });
      sentGAEvent({
        category: 'DownloadStart',
        action: '22AO_DownloadStart',
        label: 'Null',
      });
      setMarkLoading(true);
      const formData = new FormData();
      formData.append('download_type', type);
      formData.append('job_id', props.job_id);
      requestDownload({
        body: formData,
      })
        .then((obj) => {
          if (obj.code === 200) {
            window.location.href = obj.data.proxy_file[0];
            // sentGAEvent({
            //   category: 'AnimateOld',
            //   action: 'AnimateOld_DownloadSuccess',
            //   label: 'Null'
            // })
          }
          setMarkLoading(false);
        })
        .catch((err) => {
          setMarkLoading(false);
          message.error(t('downloadFail'));
          console.log(err);
        });
      return;
    }

    if (type === 'gif' || type === 'no_watermark') {
      let label = 'NoWatermark';
      if (type === 'gif') {
        label = 'GIF';
      }
      sentGAEvent({
        category: 'AnimateOld',
        action: 'AnimateOld_Download',
        label: label,
      });

      if (!Cookies.get('authorization')) {
        let obj = {
          visible: true,
          text: type === 'gif' ? 'UpgradeToDownloadAsGIF' : 'freeAccountHD',
          type: type === 'gif' ? 'UpgradeToDownloadAsGIF' : 'freeAccountHD',
        };

        dispatch(action.onExceed2M(obj));

        //没登陆

        sentGAEvent({
          category: 'Upgrade',
          action:
            type === 'gif'
              ? 'DownloadOldPhotoAsGIF_PrompShow'
              : 'DownloadNoWatermarkOldPhoto_PrompShow',
          label: 'Null',
        });
      } else if (subscription && subscription[0].status == 'Active') {
        sentGAEvent({
          category: 'DownloadStart',
          action: '22AO_DownloadStart',
          label: 'Null',
        });
        if (type === 'gif') {
          setGifLoading(true);
        } else {
          setNoMarkLoading(true);
        }
        const formData = new FormData();
        formData.append('download_type', type);
        formData.append('job_id', props.job_id);
        requestDownload({
          body: formData,
        })
          .then((obj) => {
            if (obj.code === 200) {
              window.location.href = obj.data.proxy_file[0];
              // sentGAEvent({
              //   category: 'AnimateOld',
              //   action: 'AnimateOld_DownloadSuccess',
              //   label: 'Null'
              // })
            }
            setGifLoading(false);
            setNoMarkLoading(false);
          })
          .catch((err) => {
            setGifLoading(false);
            setNoMarkLoading(false);
            message.error(t('downloadFail'));
            console.log(err);
          });
      } else {
        let obj = {
          visible: true,
          text: type === 'gif' ? 'UpgradeToDownloadAsGIF' : 'freeAccountHD',
          type: type === 'gif' ? 'UpgradeToDownloadAsGIF' : 'freeAccountHD',
        };

        dispatch(action.onExceed2M(obj));

        sentGAEvent({
          category: 'Upgrade',
          action:
            type === 'gif'
              ? 'DownloadOldPhotoAsGIF_PrompShow'
              : 'DownloadNoWatermarkOldPhoto_PrompShow',
          label: 'Null',
        });
        dispatch(
          action.onPurchaseModalObjChange({
            trigger:
              type === 'gif'
                ? 'DownloadOldPhotoAsGIF'
                : 'DownloadNoWatermarkOldPhoto',
          })
        );
      }
    }
  };

  useEffect(() => {
    if (Device.mobile()) {
      const hideDom = document.querySelectorAll('#hideTitle');
      hideDom.forEach((item) => {
        item.style.display = 'none';
      });
    }

    const imgDom = document.getElementById('exampleImg');
    imgDom.addEventListener('touchstart', () => {
      if (videoRef.current != null) {
        videoRef.current?.play();
      }
    });
    imgDom.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    return () => {
      imgDom.removeEventListener('contextmenu', (e) => {
        e.preventDefault();
      });
    };
  }, []);

  const backToEdit = useCallback(() => {
    if (fetchAbort.fetchAbort) {
      console.log('终止请求');
      fetchAbort.fetchAbort();
    }
    window.dispatchEvent(new Event('showTitle'));
    sentGAEvent({
      category: 'AnimateOld',
      action: 'AnimateOld_Reupload',
      label: 'Null',
    });
    dispatch(action.onCurrFileChange(null));
    props.backToHome();
  });

  return (
    <div className='downloadPage'>
      <div className='readyTitle'>{t('videoReady')}</div>
      <div className='imgContainer'>
        <div className='imgContent'>
          <video
            ref={videoRef}
            id='exampleImg'
            autoPlay
            loop
            muted
            className='bigImg'
            src={props.successBymp4}
          />
          <img
            alt=''
            className='smallImg'
            src={props.originUrl || localStorage.getItem('originUrl')}
          />
        </div>

        <div
          className='backToEdit'
          onClick={() => {
            backToEdit();
          }}
        >
          {t('Upload New Photo')}
        </div>
      </div>
      <div className='downloadBtn'>
        <div className='readyText'>{t('videoReady')}</div>
        <div>
          <Button
            loading={noMarkLoading}
            onClick={() => downloadFn('no_watermark')}
            icon={
              subscription && subscription[0].status == 'Active' ? (
                ''
              ) : (
                <Vip style={{ marginRight: '10px' }} />
              )
            }
            className='withoutWaterMark'
            type='default'
          >
            {t('Download Without Watermark')}
          </Button>
        </div>
        <div>
          <Button
            loading={gifLoading}
            onClick={() => downloadFn('gif')}
            icon={
              subscription && subscription[0].status === 'Active' ? (
                ''
              ) : (
                <Vip style={{ marginRight: '10px' }} />
              )
            }
            className='downloadGif'
            type='default'
          >
            {t('Download As GIF')}
          </Button>
        </div>
        <div>
          <Button
            loading={markLoading}
            onClick={() => downloadFn('watermark')}
            className='withWaterMark'
            type='default'
          >
            {t('Download With Watermark')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
